// extracted by mini-css-extract-plugin
export default {"itemWrapper":"UserInfoItem_itemWrapper__DyM8V","iconWrapper":"UserInfoItem_iconWrapper__hFnmF","text":"UserInfoItem_text__mscnb"};